import Button from "@/common/components/Button"
import Modal from "@/common/components/Modal"
import TextArea from "@/common/components/TextArea"
import { declineSchema, PrivateCompanyLeadsFunnelDeclineValidationSchema } from "@/features/privateCompanyLeadsFunnel/schemas/decline.schema"
import { zodResolver } from "@hookform/resolvers/zod"
import { useIsMutating } from "@tanstack/react-query"
import { useState } from "react"
import { SubmitHandler, useForm } from "react-hook-form"

interface DeclineModalProps {
  submit: (data?: PrivateCompanyLeadsFunnelDeclineValidationSchema) => void
  onSuccess?: () => void
  onError?: () => void
}

const DeclineModal = ({ submit, onSuccess, onError }: DeclineModalProps) => {
  const isMutating = !!useIsMutating()

  const [isOpen, setIsOpen] = useState(false)
  const [serverError, setServerError] = useState(false)

  const {
    register,
    handleSubmit,
    reset: resetForm,
    formState: { errors }
  } = useForm<PrivateCompanyLeadsFunnelDeclineValidationSchema>({
    resolver: zodResolver(declineSchema)
  })

  const handleSuccess = () => {
    resetForm()
    setServerError(false)
    setIsOpen(false)
    onSuccess?.()
  }

  const handleError = () => {
    setServerError(true)
    onError?.()
  }

  const onSubmit: SubmitHandler<PrivateCompanyLeadsFunnelDeclineValidationSchema> = (data) => {
    try {
      submit(data)
      handleSuccess()
    } catch {
      handleError()
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      onConfirm={handleSubmit(onSubmit)}      Trigger={(
        <Button
          type="button"
          variant="yellow"
          className="w-[164px]"
          name="decline_lead"
          disabled={isMutating}
        >
          Declinar
        </Button>
      )}
      title="Solicitando revisão"
      titleClass="text-2xl font-bold mb-2"
      subtitle="Preencha o motivo para revisão."
      footer="Enviar para revisão"
      body={(
        <form className="flex flex-col gap-4">
          {serverError && <p className="text-sm text-danger-soft">Ocorreu um erro no servidor, cheque os campos e tente novamente</p>}
          <TextArea
            label="Justificativa"
            errorMessage={errors?.description?.message}
            {...register('description')}
            markAsRequired
          />
        </form>
      )}
    />
  )
}

export default DeclineModal
